import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from '../../actions/ProductActions'
class ProductAdmin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: '',
            name: '',
            sku: '',
            category: 'ao',
            price: 0,
            material: '',
            img: []
        }
    }

    componentDidMount() {
        var { match } = this.props;
        if (match) {
            var id = match.params.id;
            this.props.getProductById(id);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.productItem) {
            this.setState({
                id: nextProps.productItem.id,
                name: nextProps.productItem.name,
                sku: nextProps.productItem.sku,
                category: nextProps.productItem.category,
                price: nextProps.productItem.price,
                material: nextProps.productItem.material,
                img: nextProps.productItem.img
            })
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleChangePrice = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ price: e.target.value })
        }
    }

    handleChangeImage = (e, index) => {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.img[index] = e.target.value;
        this.setState({
            img: this.state.img
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        var { id, name, sku, category, price, material, img } = this.state;
        var date = new Date();
        var product = {
            id: id,
            name: name,
            sku: sku,
            category: category,
            price: Number.parseInt(price),
            createAt: date.toJSON(),
            material: material,
            img: img
        }
        if (name === "" || sku === "" || category === "" || price === "" || material === "") {
            alert("Không được bỏ trống dữ liệu")
        } else if (id) {
            this.props.editProduct(product)
            alert("Sửa thành công");
            this.props.history.push('/products');
            window.scrollTo({
                top: document.body.scrollHeight,
                left: 0,
                behavior: 'smooth'
            });
            // console.log(this.state);
        } else {
            this.props.addProduct(product);
            alert("Thêm thành công");
            this.props.history.push('/products');
            window.scrollTo({
                top: document.body.scrollHeight,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    handleRemoveClick = (index) => {
        this.state.img.splice(index, 1);
        this.setState({
            img: this.state.img
        })
    }

    handleAddClick = () => {
        this.setState({
            img: [...this.state.img, ""]
        })
    }

    render() {
        var { name, sku, category, price, material } = this.state;
        var { match } = this.props;
        var idParams = match ? match.params.id : null;
        return (
            <>
                <div className="page__action pb-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h3 className="account__page--title">Quản lý sản phẩm</h3>
                            </div>
                            <div className="col-12">
                                <div className="contact-form">
                                    <input name="form_type" type="hidden" defaultValue="contact" />
                                    <div className="form-group">
                                        <label htmlFor="contactFormAuthor" className="">
                                            Tên sản phẩm
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            id="contactFormAuthor"
                                            className="form-control input-lg"
                                            name="name"
                                            placeholder="Name"
                                            autoCapitalize="words"
                                            value={name ? name : ''}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="contactFormName" className="">
                                            SKU
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            id="contactFormName"
                                            className="form-control input-lg"
                                            name="sku"
                                            placeholder="SKU"
                                            autoCapitalize="words"
                                            value={sku}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="contactForm1" className="">
                                            Category
                                        </label>
                                        <select
                                            id="inputState"
                                            className="form-control"
                                            name="category"
                                            value={category}
                                            onChange={this.handleChange}
                                        >
                                            <option defaultValue="ao" value="ao">Áo</option>
                                            <option value="ao-khoac">Áo khoác</option>
                                            <option value="quan">Quần</option>
                                            <option value="giay">Giày</option>
                                            <option value="vay-dam">Váy đầm</option>
                                            <option value="bo-mac-nha">Bộ mặc nhà</option>
                                            <option value="tui-xach">Túi xách</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="contactForm2" className="">
                                            Price
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            id="contactForm2"
                                            className="form-control input-lg"
                                            name="price"
                                            placeholder="Price"
                                            autoCapitalize="words"
                                            value={price}
                                            onChange={this.handleChangePrice}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="contactForm3" className="">
                                            Material
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            id="contactForm3"
                                            className="form-control input-lg"
                                            name="material"
                                            placeholder="Material"
                                            autoCapitalize="words"
                                            value={material}
                                            onChange={this.handleChange}
                                        />
                                    </div>

                                    {
                                        this.state.img ? this.state.img.map((item, index) => {
                                            return (
                                                <div className="form-group form-imge" key={index}>
                                                    <label htmlFor="" className="">
                                                        Hình ảnh {index + 1}
                                                    </label>
                                                    <input
                                                        required
                                                        type="text"
                                                        name="img"
                                                        placeholder="Url image (hơi cùi ạ :v)"
                                                        className="form-control input-lg"
                                                        onChange={(e) => this.handleChangeImage(e, index)}
                                                        value={item}
                                                    />
                                                    <button
                                                        className="btn btn-warning" style={{ width: '20%' }}
                                                        onClick={() => this.handleRemoveClick(index)}
                                                    >Xoá</button>
                                                </div>
                                            )
                                        }) : ['']
                                    }
                                    <button
                                        className="btn btn-info mt-2 mb-3"
                                        onClick={() => this.handleAddClick()}
                                    >Thêm hình ảnh</button>
                                    <div className="form-group">
                                        <button
                                            className="btn btn-primary btn-lg btn-rb mr-3"
                                            onClick={this.handleSubmit}
                                        >
                                            {idParams ? "Sửa sản phẩm" : "Thêm sản phẩm"}
                                        </button>
                                        <Link to="/products"
                                            className="btn btn-outline-secondary btn-lg"
                                        >Huỷ</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        productItem: state.products.productItem
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addProduct: (product) => {
            dispatch(actions.fetchAPIAddProduct(product))
        },
        editProduct: (product) => {
            dispatch(actions.fetchAPIEditProduct(product))
        },
        getProductById: (id) => {
            dispatch(actions.fetchAPIProductItem(id))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductAdmin);
